export interface IUmkreis {
    lat: string;
    lng: string;
    rad: number;
    sort: "dist" | "price";
    type: ITankType;
}

export enum ITankType {
    e5 = 'e5',
    e10 = 'e10',
    diesel = 'diesel'
}

export interface ITankStation {
    id: string;
    name: string;
    brand: string;
    street: string;
    houseNumber: string;
    postcode: number;
    place: string;
    lat: string;
    lng: string;
    dist: number;
    e5: number;
    e10: number;
    diesel: number;
    isOpen: boolean;
    price: number;
    state?: string;
    openingTimes?: string[];
    wholeDay?: boolean;
    overrides?: string[];
    favorit: boolean;
}
